<template>
  <v-container>
      <v-row>
            <v-dialog v-model="showDialog" max-width="600">
                <v-card>
                    <v-system-bar flat color="white">
                        <v-spacer></v-spacer>
                        <v-btn text class="mt-3" style="color:#B45C5C" @click="showDialog=false">Close <v-icon small right>mdi-close</v-icon></v-btn>
                    </v-system-bar>
                    <v-card-text class="text-center headline mt-6" style="color:#48c074;">Transaction Details</v-card-text>
                    <v-card-text>
                    <v-simple-table>
                        <template v-slot:default>
                        <thead>
                            <tr>
                            <th class="text-center black--text">Attribute</th>
                            <th class="text-center black--text">Value</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td class="text-center">Amount</td>
                                <td class="text-center">&#8358;{{showTrans.amount}}</td>
                            </tr>
                            <tr>
                                <td class="text-center">Estimated Return</td>
                                <td class="text-center">&#8358;{{showTrans.estimated_return}}</td>
                            </tr>
                            <tr>
                                <td class="text-center">Investment Code</td>
                                <td class="text-center">{{showTrans.investment_code}}</td>
                            </tr>
                            
                            <tr>
                                <td class="text-center">Units Bought</td>
                                <td class="text-center">{{showTrans.units_bought}}</td>
                            </tr>
                            
                            <tr>
                                <td class="text-center">Payment Ref</td>
                                <td class="text-center">{{showTrans.transRef}}</td>
                            </tr>
                            <tr>
                                <td class="text-center">Status</td>
                                <td class="text-center">{{showTrans.status}}</td>
                            </tr>
                            <tr>
                                <td class="text-center">Date Paid</td>
                                <td class="text-center">{{showTrans.date_paid}}</td>
                            </tr>
                        </tbody>
                        </template>
                    </v-simple-table>
                    </v-card-text>
                    <v-card-actions>
                    <v-spacer></v-spacer>
                    
                    
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
        <h3 class="mt-7">Transactions</h3>
      <v-row class="mt-3">
                   <v-col>
                        <v-card>
                            <v-card-title style="color:#48c074">
                                All Transactions
                            </v-card-title>
                            <v-data-table
                                :headers="transHeaders"
                                :items="Transactions"
                                hide-default-footer=""
                                :items-per-page="5"
                                no-data-text='No Recent Transaction For Display'
                                >
                                <template v-slot:item.estimated_return="{ item }">
                                    <span class="black--text">&#8358;{{item.estimated_return}}</span>
                                </template>
                                <template v-slot:item.desc="{ item }">
                                    <span class="black--text">{{item.description}}</span>
                                </template>
                                <template v-slot:item.type="{ item }">
                                    <span class="black--text">{{item.paymentType}}</span>
                                </template>
                                <template v-slot:item.date="{ item }">
                                    <span class="black--text">{{item.datePerformed}}</span>
                                </template>
                                <template v-slot:item.amount="{ item }">
                                    
                                    <span class="black--text">&#8358;{{item.amount}}</span>
                                </template>
                                <template v-slot:item.action="{ item }">
                                    <v-btn text @click="show(item)" style="border: 1px #48c074 solid; color:#48c074" class="text-none" small>View</v-btn>
                                </template>
                            </v-data-table>
                        </v-card>
                   </v-col>
                </v-row>
  </v-container>
</template>

<script>
export default {
    data(){
        return{
            transHeaders: [
                     {
                        text: 'Amount',
                        align: 'start',
                        sortable: false,
                        value: 'amount',
                    },
                    { text: 'Status', value: 'status' },
                    { text: 'Estimated Return', value: 'estimated_return' },
                    { text: 'Date Paid', value: 'date_paid' },
                    { text: '', value: 'action' },
                    
                
                
                ],
                trans:[
                    {amount:'90,000', description:'Investment Payment', status:'Sucessful', trans_type:'Wallet Top Up', date_performed:'2020-09-08 08:15:03'}
                ],
                showDialog:false,
                showTrans:{},
        }
    },
    computed:{
        Transactions(){
            let transact = this.$store.state.farm.transactions
                for(let i=0; i<transact.length; i++){
                transact[i].date_paid = transact[i].date_paid.slice(0, 19).replace('T', ' ')
                transact[i].amount = parseFloat(transact[i].amount).toFixed(2)
                transact[i].amount = transact[i].amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                transact[i].estimated_return = parseFloat(transact[i].estimated_return).toFixed(2)
                transact[i].estimated_return = transact[i].estimated_return.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            }
            return transact
            }
    },
    methods:{
        show(item){
                this.showTrans=item
                this.showDialog=true
            },
    },
    created(){
        this.$store.dispatch("GetTransactions",{id:this.$store.state.auth.logindetails.data._id})
        .then(()=>{ 
        })
        .catch(()=>{
        });
    }
}
</script>

<style>

</style>